// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../../../images/empty_content.svg");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = " <div class=\"content-empty-state\"> <svg-icon src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"></svg-icon> <h4>{{ $ctrl.message }}</h4> <h5>{{ $ctrl.messageBody }}</h5> </div> ";
// Exports
module.exports = code;